import { render } from "./ImportPostsModal.vue?vue&type=template&id=6dcecd2d&ts=true"
import script from "./ImportPostsModal.vue?vue&type=script&lang=ts"
export * from "./ImportPostsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__